/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S9_Li2Inputs */

const tr_mesafeli_s9_li2 = /** @type {(inputs: Mesafeli_S9_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI özellikleri OpenAI, Anthropic, Google ve diğer alt sağlayıcılar üzerinden işlenebilir; Müşteri Platform'a girdiği veriler için bu alt işleme süreçlerini kabul eder.`)
};

const en_mesafeli_s9_li2 = /** @type {(inputs: Mesafeli_S9_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI features may be processed via OpenAI, Anthropic, Google and other sub-providers; the Customer accepts these sub-processing operations for the data he enters into the Platform.`)
};

const de_mesafeli_s9_li2 = /** @type {(inputs: Mesafeli_S9_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-Funktionen können über OpenAI, Anthropic, Google und weitere Unterauftragnehmer verarbeitet werden; der Kunde akzeptiert diese Unterverarbeitungsvorgänge für die von ihm in die Plattform eingegebenen Daten.`)
};

const ru_mesafeli_s9_li2 = /** @type {(inputs: Mesafeli_S9_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Функции AI могут обрабатываться через OpenAI, Anthropic, Google и других субпоставщиков; Клиент принимает такую субобработку в отношении данных, которые он вводит в Платформу.`)
};

/**
* | output |
* | --- |
* | "AI features may be processed via OpenAI, Anthropic, Google and other sub-providers; the Customer accepts these sub-processing operations for the data he ente..." |
*
* @param {Mesafeli_S9_Li2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s9_li2 = /** @type {((inputs?: Mesafeli_S9_Li2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S9_Li2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s9_li2(inputs)
	if (locale === "de") return de_mesafeli_s9_li2(inputs)
	if (locale === "ru") return ru_mesafeli_s9_li2(inputs)
	return tr_mesafeli_s9_li2(inputs)
});